import React from 'react';
import { useHistory } from 'react-router-dom';
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import randomImg from '../../../assets/images/iconoWiki.svg';
import { useStyles, Button } from './styles';

const PortalSuggestion = ({ sugerence }) => {
  const history = useHistory();
  const classes = useStyles();

  return (
    <Card className={classes.root}>
      <CardActionArea
        onClick={() => history.push(`/insight_factory/insight/${sugerence.id}`)}
      >
        <CardMedia
          component="img"
          height="140"
          image={
            sugerence?.icono?.urlFirmada || randomImg
          }
        />
        <CardContent>
          <Typography className={classes.title}>{sugerence.titulo}</Typography>
          <Typography
            className={classes.testResult}
          >
            {`Visitas ${sugerence.visualizaciones}`}
          </Typography>
          <Typography
            className={classes.testResult}
          >
            {sugerence.unidad}
          </Typography>
        </CardContent>
      </CardActionArea>
      <CardActions>
        <Button
          width="fullWidth"
          onClick={() => history.push(`/insight_factory/insight/${sugerence.id}`)}
        >
          Ir al insight
        </Button>
      </CardActions>
    </Card>
  );
};

export default PortalSuggestion;
